var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgAuthMail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61096 9.11133C2.61096 8.69711 2.94675 8.36133 3.36096 8.36133H29.5666C29.9808 8.36133 30.3166 8.69711 30.3166 9.11133V24.1113C30.3166 24.5255 29.9808 24.8613 29.5666 24.8613H3.36096C2.94675 24.8613 2.61096 24.5255 2.61096 24.1113V9.11133ZM5.92243 9.86133L14.9244 15.6273C15.8226 16.2025 16.9726 16.2053 17.8735 15.6343L26.9822 9.86133H5.92243ZM28.8166 10.4746L18.6765 16.9013C17.2832 17.7843 15.5044 17.7801 14.1154 16.8904L4.11096 10.4824V23.3613H28.8166V10.4746Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgAuthMail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/auth-mail.142d51e47b272cdb7dfee1948b1383e8.svg";